module.exports = __webpack_public_path__ + "static/media/maxigo-difficulty-red.91692299.png";